import { simpleOffsetPaginationSchema } from '@crowdfpl/domain/pagination';
import { seasonEntitySchema } from '@crowdfpl/domain/season';
import { z } from 'zod';

export const SeasonSchema = seasonEntitySchema;

export const SeasonsListResponseSchema = z.object({
  seasons: z.array(SeasonSchema),
  pagination: simpleOffsetPaginationSchema,
});

export type SeasonDto = z.infer<typeof SeasonSchema>;
export type SeasonsListResponse = z.infer<typeof SeasonsListResponseSchema>;
